/**
 * Creates a persistent validator manager
 *
 * Manages registration and validation of input fields grouped by step
 */
const createValidatorManager = () => {
  const validatorMap = new Map();

  /**
   * Registers a validator function for a given step/input pair.
   */
  const registerInputValidator = (stepName, inputName, validatorFn) => {
    // Get existing input validator map for this step
    const stepValidators = validatorMap.get(stepName) || new Map();

    // Set or replace the validator for the specific input name
    stepValidators.set(inputName, validatorFn);
    validatorMap.set(stepName, stepValidators);
  };

  /**
   * Returns a function that runs all validators for a given step.
   */
  const getStepValidator = (stepName) => {
    return () => {
      const stepValidators = validatorMap.get(stepName);
      if (!stepValidators || stepValidators.size === 0) return true;

      for (const [, validatorFn] of stepValidators.entries()) {
        try {
          const isValid = validatorFn();
          if (!isValid) {
            return false;
          }
        } catch {
          return false;
        }
      }

      return true;
    };
  };

  /**
   * Runs all registered validators and returns whether the form is valid.
   *
   * @returns {Object} Result of validation:
   *   - { isValid: true } if all validations pass
   *   - { isValid: false, step: string, input: string } if a validation fails
   *   - { isValid: false, step: string, input: string, error: string } if a validation throws an error
   */
  const getAllValidators = () => {
    console.log('validatorMap', validatorMap)
    if (validatorMap.size === 0) return { isValid: true };

    for (const [stepName, stepValidatorMap] of validatorMap.entries()) {
      for (const [inputName, validatorFn] of stepValidatorMap.entries()) {
        try {
          const isValid = validatorFn();

          console.log(stepName, inputName, isValid ? 'passed' : 'failed')
          if (!isValid) {
            return {
              isValid: false,
              step: stepName,
              input: inputName,
            };
          }
        } catch (error) {
          return {
            isValid: false,
            step: stepName,
            input: inputName,
            error: error.message || error.toString(),
          };
        }
      }
    }

    return { isValid: true };
  };

  return {
    registerInputValidator,
    getStepValidator,
    getAllValidators,
  };
};

export const validatorManager = createValidatorManager();
